import React from 'react';
import * as S from './styles';

interface CheckboxFieldProps {
    id: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    accentColor?: string;
    children: React.ReactNode;
}

export const CheckboxField = ({
    id,
    checked,
    onChange,
    accentColor,
    children,
}: CheckboxFieldProps) => (
    <S.Row>
        <S.Input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
            $accentColor={accentColor}
        />
        <S.Label htmlFor={id} $accentColor={accentColor}>{children}</S.Label>
    </S.Row>
);

export { S as CheckboxFieldStyles };
